import { colors } from 'app/styles/colors';

export const xAxisTickCount = 7;

export const strokeGradientId = 'gradient1';

export const shadowId = 'dropShadow1';

export const lineStyle = {
  strokeLineJoin: 'round',
  strokeWidth: 4,
  stroke: `url(#${strokeGradientId})`,
  fill: 'none',
  filter: `url(#${shadowId})`,
};

export const barStyle = {
  fill: colors.graphs.bars,
  strokeWidth: 0,
};

export const xAxisStyle = {
  line: {
    display: 'none',
  },
  text: {
    stroke: 'none',
    fill: colors.graphs.axisLabels,
    fontWeight: 300,
    fontSize: '12px',
  },
};

/** just enough room for a compact price like $77.32k */
export const yAxisWidth = 58;

export const yAxisStyle = {
  line: {
    display: 'none',
  },
  // no `ticks` key here: in react-vis that styles the whole tick group, so hiding it
  // takes the label with it. xAxisStyle above leaves it alone for the same reason.
  text: {
    stroke: 'none',
    fill: colors.graphs.axisLabels,
    fontWeight: 300,
    fontSize: '11px',
  },
};

export const verticalLinesStyle = {
  stroke: colors.graphs.verticalLine,
};

export const crosshairStyle = {
  line: {
    background: colors.graphs.crosshair,
  },
  box: {
    display: 'none',
  },
};
